import {GREY_INFO_COLOR} from "../../../../../../../themes/themeConfigurator";

const RAIL_HEIGHT = 4;

const styles = (theme) => ({
  rail: {
    height: RAIL_HEIGHT,
  },
  track: {
    height: RAIL_HEIGHT, // match rail height
  },
  mark: {
    backgroundColor: GREY_INFO_COLOR,
    width: 1,
    height: 4,
    transform: 'translate(-50%, 16px)',
    opacity: 1,
    borderRadius: 1,
  },
  markLabel: {
    fontSize: 12,
    top: 36,
    color: '#202A38',
    textAlign: 'center',
  },
  thumb: {
    width: 20,
    height: 20,
    marginTop: -8,
    marginLeft: -10,
    "&.hidden": {
      display: 'none'
    }
  },
  labelTooltip: {
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    padding: '4px 12px',
    borderRadius: '4px',
    fontSize: 16,
  },
  tooltipArrow: {
    "&::before": {
      // border for tooltip with placement=top
      borderColor: `${theme.palette.primary.main} transparent transparent transparent !important`
    }
  },
  tooltipPopper: {
    zIndex: 0,
    '&.disabled': {
      opacity: 0.5
    }
  }
});

export default styles;